import React, { ReactElement, useCallback } from 'react';
import FileSelectButton from '../components/file-select-button';
import { loadValues } from '../features/values/potterware-file';
import { useDispatch } from 'react-redux';
import ToolsSection from './tools-section';
import { NameLabel } from '../config';
import ModelInput from '../components/inputs/model-input';

function UploadView(): ReactElement {
  const { inputs, label } = PW.config.uploadPanel;
  const potterwareFileInput = inputs.find(
    (i) => typeof i !== 'string' && i.name === '$potterware-file'
  ) as NameLabel;

  const dispatch = useDispatch();

  const onPotterwareFileChange = useCallback(
    (files: FileList | null): void => {
      if (!files) return;

      const file = files[0];
      dispatch(loadValues(file));
    },
    [dispatch]
  );

  return (
    <ToolsSection title={label}>
      <div className="inputs-list">
        {inputs.map((config) => {
          if (typeof config !== 'string' && config.name === '$potterware-file')
            return (
              <div className="inputs-list__item" key={config.name}>
                <FileSelectButton
                  id="potterwareFileUpload"
                  label={potterwareFileInput.label}
                  accept=".pwr"
                  onChange={onPotterwareFileChange}
                />
              </div>
            );
          else {
            const name = typeof config === 'string' ? config : config.name;

            return (
              <div className="inputs-list__item" key={name}>
                <ModelInput config={config} />
              </div>
            );
          }
        })}
      </div>
    </ToolsSection>
  );
}

export default UploadView;
